
<template>
  <div id="UAV">
    <div class="font">
      <span class="introSubTitle"><b>无人机遥感在线实时处理系统</b></span>
      <p class="textStyle">提出“边飞行-边传输-边处理-边服务”的无人机遥感数据实时智能服务模式，实现了机载在线实时定位、变化检测与目标跟踪，研制机载遥感信息实时智能处理系统，得到成功应用。</p>
    </div>
    <!-- <br/>   -->
    <img width="100%" src="@/assets/img/scientific/UAV_data-1.jpg" />
    <p class="img_figure">无人机遥感数据在线处理</p>
    <el-row :gutter="10">
      <el-col :span="12">
        <img width="100%" src="@/assets/img/scientific/UAV_data-2.jpg" />
      </el-col>
      <el-col :span="12">
        <img width="100%" src="@/assets/img/scientific/UAV_data-3.png" />
      </el-col>
    </el-row>
    <p class="img_figure">无人机目标追踪</p>
  </div>
</template>

<script>
// import myVideo from "../../node_modules/vue-video";

export default {
  data() {
    return {

    };
  },
};
</script>

<style lang="less">
#UAV {
  margin-top: 20px;
  .img_figure{
    display: flex;
    justify-content: center;
    font-size: 14px;
    color: #4f4f4f;
  }
  // .font {
  //   // font-family: "Times New Roman", Times, serif;
  // }
}
</style>
